<template>
  <div class="data-content-box">
    <div
      v-if="!dataManageTreeVisible"
      class="icon-box">
      <icon-svg
        icon-class="ic-ico_an"
        class="icon"
        title="展开目录树"
        @click.native="openDataManageTree" />
    </div>
    <DragPanel v-show="dataManageTreeVisible">
      <DataManageTree
        :width="242"
        ref="dataManageTree"
        :data="treeData"
        :nodeClick="handleNodeClick"
        :hideDataManageTree="hideDataManageTree" />
    </DragPanel>
    <div class="data-content page-primary">
      <div
        v-if="loading"
        class="loading-box">
        <div
          v-loading="true"
          class="loading" />
      </div>
      <Breadcrumb
        :breadcrumbList="breadcrumbList"
        :breadcrumbClick="breadcrumbClick" />
      <div class="operate-area">
        <div class="common-button-box">
          <div v-if="isButtonVisible('upload')">
            <el-button
              id="vector-upload"
              class="upload-btn primary-btn gr9"
              type="primary"
              size="small"
              @click="uploadFile">
              上传
            </el-button>
          </div>
          <div v-if="isButtonVisible('newFolder')">
            <el-button
              class="normal-btn gr9"
              size="small"
              @click="addNode(1)"
              >新建文件夹</el-button
            >
          </div>
          <div
            v-if="isBatchButtonVisible('modelBatchOperate', '')"
            class="common-dropdown-box">
            <el-dropdown
              placement="bottom-start"
              @command="modelBatchOperate">
              <el-button
                size="small"
                class="normal-btn">
                批量操作 <i class="el-icon-arrow-down" />
              </el-button>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-menu dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item
                  v-if="isBatchButtonVisible('download', 'modelBatchOperate')"
                  command="2">
                  下载
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('moveTo', 'modelBatchOperate')"
                  command="3">
                  移动到
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('deleteNode', 'modelBatchOperate')"
                  command="4">
                  删除
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="isBatchButtonVisible('share', 'modelBatchOperate')"
                  command="5">
                  分享
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入文件名"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
      <div
        v-if="!modelTableVisible"
        class="common-empty-box"
        key="emptyPage">
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="empty-text">抱歉，没有找到相关内容</div>
          </template>
          <div
            class="empty-tips"
            v-if="isButtonVisible('upload')">
            支持的矢量数据格式：KML、KMZ及SHP（SHP需以shp.zip打包上传，一级目录需包含.shp、.shx、.prj、.dbf文件）
          </div>
          <div class="common-button-box text-center-c btn-group-primary">
            <el-button
              v-if="isButtonVisible('upload')"
              key="uploadBtn"
              type="primary"
              size="small"
              class="upload-btn primary-btn gr9"
              id="empty-vector-upload"
              @click="uploadFile">
              上传
            </el-button>
            <el-button
              v-if="isButtonVisible('newFolder')"
              class="normal-btn"
              size="small"
              @click="addNode(1)">
              新建文件夹
            </el-button>
          </div>
        </bj-empty>
      </div>
      <div
        v-show="modelTableVisible"
        class="data-view-box">
        <ModelTable
          :operaWidth="200"
          ref="modelTable"
          v-show="modelTableVisible"
          schemeType="Vector"
          :rootNodeId="rootNodeId"
          :nodeId="selectNodeData.nodeId"
          :name="keywords"
          :customUploader="customUploader"
          :updateModelTableVisible="updateModelTableVisible"
          :refreshCatalogTree="refreshCatalogTree"
          :handleCellClick="handleCellClick"
          :reNameNode="reNameNode"
          :openMoveTreeDialog="openMoveTreeDialog"
          :openShareDialog="openShareDialog"
          :openVectorConfigDialog="openVectorConfigDialog" />
      </div>
    </div>
    <AddNodeDialog
      :visible="nodeDialogVisible"
      :title="nodeDialogTitle"
      schemeType="Vector"
      :nodeType="nodeType"
      :editMode="editMode"
      :nodeInfo="nodeInfo"
      :submitNode="submitNode"
      :closeDialog="closeNodeDialog" />
    <MoveTreeDialog
      :visible="moveTreeDialogVisible"
      :data="moveTreeData"
      :nodeClick="moveTreeNodeClick"
      :submitMove="submitMove"
      :closeDialog="closeMoveTreeDialog" />
    <ShareDialog
      :visible="shareDialogVisible"
      resourceType="dataSet"
      :resourceList="dataSetsToShare"
      :closeDialog="closeShareDialog" />
    <VectorConfigDialog
      :visible="vectorConfigDialogVisible"
      :initVectorLodInfo="vectorLodInfo"
      :submitConvert="submitConvert"
      :closeDialog="closeVectorConfigDialog" />
    <VerifyMsgDialog :customUploader="customUploader" />
  </div>
</template>

<script>
import DragPanel from '@/components/DragPanel.vue'
import DataManageTree from '@/components/module/dataManage/DataManageTree.vue'
import Breadcrumb from '@/components/module/dataManage/Breadcrumb.vue'
import MoveTreeDialog from '@/components/module/dataManage/MoveTreeDialog.vue'
import AddNodeDialog from '@/components/module/dataManage/AddNodeDialog.vue'
import ModelTable from '@/components/module/dataManage/ModelTable.vue'
import ShareDialog from '@/components/ShareDialog.vue'
import VectorConfigDialog from '@/components/module/dataManage/VectorConfigDialog.vue'
import VerifyMsgDialog from '@/components/module/dataManage/VerifyMsgDialog.vue'

import CustomUploader from '@/utils/customUploader'
import { Store } from '@/utils/store'
import { vectorButtons } from '@/utils/dictionary'
import { getParentNode, findNodeById } from '@/utils/generalMethods'

import {
  getVectorTreeService,
  addVectorNodeService,
  modifyVectorNodeNameService,
  moveVectorNodeService,
  getVectorLodConfigService,
  saveVectorLodConfigService,
  submitVectorConvertService
} from '@/service/interface'

export default {
  data() {
    return {
      dataManageTreeVisible: true,
      rootNodeId: '',
      rootNodeData: {},
      treeData: [],
      selectNodeData: {},

      loading: true,
      modelTableVisible: false,

      keywords: '',
      breadcrumbList: [{ id: 'all', name: '矢量数据' }],

      nodeDialogVisible: false,
      nodeDialogTitle: '',
      nodeType: 0,
      nodeInfo: null,
      editMode: '',

      moveTreeDialogVisible: false,
      moveTreeData: [],
      moveNodeData: null,

      shareDialogVisible: false,
      dataSetsToShare: [],

      vectorConfigDialogVisible: false,
      dataSetsToConvert: [],
      vectorLodInfo: {}
    }
  },
  components: {
    DragPanel,
    DataManageTree,
    MoveTreeDialog,
    AddNodeDialog,
    Breadcrumb,
    ModelTable,
    ShareDialog,
    VectorConfigDialog,
    VerifyMsgDialog
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'Vector')
    if (find) {
      this.customUploader = find.uploader
      this.customUploader.setCurrDataSetId('')
      this.customUploader.setUploadPathName('')
    } else {
      let uploaderOption = {
        accept: {
          title: '矢量数据文件',
          extensions: '*',
          mimeTypes: '.shp.zip,.kml,.kmz'
        }
      }
      this.customUploader = new CustomUploader('Vector', uploaderOption)
    }

    let projId = this.$route.params.projId
    this.customUploader.setCurrProjId(projId)
  },
  mounted() {
    this.initData().then(() => {
      let nodeId = sessionStorage.getItem('VectorNodeId')
      if (nodeId) {
        let selectData = this.findNodeById(this.treeData, nodeId)
        let domRef = this.$refs.dataManageTree
        if (selectData && domRef) {
          let node = domRef.getNode(selectData.nodeId)
          this.handleNodeClick(selectData, node)
        }
        sessionStorage.removeItem('VectorNodeId')
      } else {
        let domRef = this.$refs.dataManageTree
        if (domRef) {
          let node = domRef.getNode(this.rootNodeData.nodeId)
          this.handleNodeClick(this.rootNodeData, node)
        }
      }
    })
    this.customUploader.on('startUploadFile', this.onStartUploadFile)
    this.$eventManage.on('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.on('refreshTable', this.refreshTable)
  },
  beforeDestroy() {
    this.customUploader.off('startUploadFile', this.onStartUploadFile)
    this.$eventManage.off('refresh-catalogTree', this.refreshCatalogTree)
    this.$eventManage.off('refreshTable', this.refreshTable)
  },
  methods: {
    openDataManageTree() {
      this.dataManageTreeVisible = true
    },
    hideDataManageTree() {
      this.dataManageTreeVisible = false
    },
    initData() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getVectorTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            if (result) {
              this.rootNodeData = result
              this.rootNodeId = result.nodeId
              this.treeData = [result]
              this.moveTreeData = [result]
              resolve()
            } else {
              this.$message.error('获取资源目录失败，请稍后再试')
              this.$router.push('../../../projectList')
            }
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshCatalogTree() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getVectorTreeService({ projId }).then(response => {
          if (response.isSuccess) {
            let result = response.data
            this.rootNodeData = result
            this.treeData = [result]
            this.moveTreeData = [result]
            this.$nextTick(() => {
              let nodeId = this.selectNodeData.nodeId
              let selectData = this.findNodeById([result], nodeId)
              let domRef = this.$refs.dataManageTree
              if (selectData && domRef) {
                this.selectNodeData = selectData
                domRef.setCurrentKey(selectData.nodeId)
              }
            })
            resolve()
          } else {
            this.$message.error(response.errMsg)
            this.$router.push('../../../projectList')
          }
        })
      })
    },
    refreshTable() {
      if (this.$refs.modelTable) {
        if (!this.selectNodeData.nodeId) return
        this.$refs.modelTable.uploadDataList().then(total => {
          this.updateModelTableVisible(total)
        })
      }
    },
    search() {
      sessionStorage.removeItem('pageInfo')
      this.$refs.modelTable.uploadDataList(1)
    },
    handleCellClick(row) {
      let node = this.$refs.dataManageTree.getNode(row.nodeId)
      this.handleNodeClick(row, node)
    },
    handleNodeClick(nodeData, node) {
      this.loading = true
      this.selectNodeData = nodeData
      this.breadcrumbList = this.getBreadCrumbList(node)

      this.keywords = ''
      this.$refs.dataManageTree.setCurrentKey(nodeData.nodeId)
      sessionStorage.setItem('VectorNodeId', nodeData.nodeId)

      this.$nextTick(() => {
        this.$refs.modelTable.uploadDataList(1).then(total => {
          this.updateModelTableVisible(total)
          this.loading = false
        })
      })
    },
    getBreadCrumbList(node) {
      let breadcrumbList = []
      if (node) {
        let parentNodes = []
        this.getParentNode(node, parentNodes)
        parentNodes.reverse()
        parentNodes.forEach(item => {
          let nodeData = item.data
          if (nodeData.nodeType === 0) {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: '矢量数据'
            })
          } else {
            breadcrumbList.push({
              id: nodeData.nodeId,
              name: nodeData.nodeName
            })
          }
        })
      } else {
        breadcrumbList = [{ id: this.rootNodeId, name: '矢量数据' }]
      }
      return breadcrumbList
    },
    breadcrumbClick(data) {
      if (this.breadcrumbList.length === 1) return
      if (data.id === this.rootNodeId) {
        this.selectNodeData = this.rootNodeData
        this.$refs.dataManageTree.setCurrentKey(null)
        this.handleNodeClick(this.rootNodeData)
      } else {
        let selectData = this.findNodeById(this.treeData, data.id)
        let node = this.$refs.dataManageTree.getNode(selectData.nodeId)
        this.handleNodeClick(selectData, node)
      }
    },
    uploadFile() {
      this.customUploader.setStatus('waiting')
    },
    onStartUploadFile() {
      this.$eventManage.fire('startUploadFile')
    },
    modelBatchOperate(command) {
      switch (command) {
        case '2':
          this.$refs.modelTable.batchDownloadFiles()
          break
        case '3':
          this.$refs.modelTable.batchMoveNode()
          break
        case '4':
          this.$refs.modelTable.batchDeleteNode()
          break
        case '5':
          this.$refs.modelTable.batchShare()
          break
      }
    },
    addNode(nodeType) {
      let node = this.$refs.dataManageTree.getNode(this.selectNodeData.nodeId)
      if (node && node.level > window.maxLevel) {
        this.$message.warning(`最多只支持${window.maxLevel + 1}级`)
        return false
      }

      this.nodeDialogVisible = true
      this.nodeDialogTitle = '新建文件夹'
      this.nodeType = nodeType
      this.editMode = 'addNode'
    },
    reNameNode(nodeInfo) {
      let nodeType = nodeInfo.nodeType

      this.nodeDialogVisible = true
      this.nodeDialogTitle = nodeType === 1 ? '重命名文件夹' : '重命名模型组'
      this.nodeType = nodeType
      this.editMode = 'reNameNode'
      this.nodeInfo = nodeInfo
    },
    closeNodeDialog() {
      this.nodeDialogVisible = false
      this.nodeDialogTitle = ''
      this.nodeType = 0
      this.editMode = ''
      this.nodeInfo = null
    },
    submitNode(paramsInfo) {
      return new Promise(resolve => {
        if (this.editMode === 'addNode') {
          let params = {
            parentId: this.selectNodeData.nodeId,
            nodeNames: [paramsInfo.nodeName]
          }
          if (this.nodeType === 1) {
            addVectorNodeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data[0]
                this.refreshCatalogTree().then(() => {
                  let selectData = this.findNodeById(this.treeData, data.nodeId)
                  if (selectData) {
                    let node = this.$refs.dataManageTree.getNode(
                      selectData.nodeId
                    )
                    this.handleNodeClick(selectData, node)
                  }
                })
                resolve(response)
              } else {
                resolve(response)
              }
            })
          }
        }

        let dataInfo = this.nodeInfo
        if (this.editMode === 'reNameNode') {
          let params = {
            nodeId: dataInfo.nodeId,
            nodeName: paramsInfo.nodeName
          }
          modifyVectorNodeNameService(params).then(response => {
            if (response.isSuccess) {
              this.refreshCatalogTree()
              this.refreshTable()
              resolve(response)
            } else {
              resolve(response)
            }
          })
        }
      })
    },
    openMoveTreeDialog(datas) {
      this.nodesToMove = datas
      this.moveTreeDialogVisible = true
    },
    moveTreeNodeClick(data, node) {
      this.moveNodeData = null

      if (data.nodeId === this.selectNodeData.nodeId) {
        this.$message.error('数据已在当前目录中，请选择其他目录！')
        return
      }

      let moveDataIds = this.nodesToMove.map(el => el.nodeId)
      if (moveDataIds.includes(data.nodeId)) {
        this.$message.error('不能移动到自身目录之下，请选择其他目录！')
        return
      }

      let nodesToMoveNodeType = this.nodesToMove.map(el => el.nodeType)[0]
      if (nodesToMoveNodeType === 1 && node.level > window.maxLevel) {
        this.$message.error(`文件夹最多支持${window.maxLevel + 1}级，请选择其他目录！`)
        return
      }

      let parentNodes = []
      this.getParentNode(node, parentNodes)
      let parentNodeIds = parentNodes.map(el => el.data.nodeId)
      parentNodeIds.forEach(item => {
        if (moveDataIds.includes(item)) {
          this.$message.error('不能移动到子目录之下，请选择其他目录！')
          return
        }
      })

      this.moveNodeData = data
    },
    submitMove() {
      if (!this.moveNodeData) {
        this.$message.error('请选择有效的目标目录！')
        return
      }

      let params = {
        rootId: this.rootNodeId,
        targetNodeId: this.moveNodeData.nodeId,
        nodeIds: this.nodesToMove.map(el => el.nodeId)
      }
      moveVectorNodeService(params).then(response => {
        if (response.isSuccess) {
          this.refreshCatalogTree()
          this.refreshTable()

          this.$message.success('移动成功!')
          this.moveNodeData = null
          this.nodesToMove = []
          this.moveTreeDialogVisible = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    closeMoveTreeDialog() {
      this.moveNodeData = null
      this.nodesToMove = []
      this.moveTreeDialogVisible = false
    },
    openShareDialog(dataSetsToShare) {
      this.dataSetsToShare = dataSetsToShare
      this.shareDialogVisible = true
    },
    closeShareDialog() {
      this.dataSetsToShare = []
      this.shareDialogVisible = false
    },
    openVectorConfigDialog(dataSets) {
      this.dataSetsToConvert = dataSets
      let dataSetInfo = dataSets[0]
      let dataSetId = dataSetInfo.dataSetId
      getVectorLodConfigService({ dataSetId }).then(response => {
        if (response.isSuccess) {
          let vectorLodInfo = response.data
          this.vectorLodInfo = vectorLodInfo
          this.vectorConfigDialogVisible = true
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    submitConvert(params) {
      let promiseArray = []
      this.dataSetsToConvert.forEach(item => {
        let promise = this.addVectorToConvertQueue(item.dataSetId, params.lod)
        promiseArray.push(promise)
      })
      this.loopRequest(promiseArray, 5)
        .then(exceptionFiles => {
          let dataSetNameList = []
          exceptionFiles.forEach(item => {
            let find = this.dataSetsToConvert[item.index]
            if (find) {
              dataSetNameList.push(find.dataSetName)
            }
          })

          if (dataSetNameList.length) {
            let message = this.getWarningMessage(
              dataSetNameList,
              '矢量已转换成功,请勿重复提交转换!'
            )
            this.$message.error(message)
          }

          this.refreshCatalogTree()
          this.refreshTable()

          this.closeVectorConfigDialog()
        })
        .catch(() => {
          this.refreshCatalogTree()
          this.refreshTable()

          this.closeVectorConfigDialog()
        })
    },
    addVectorToConvertQueue(dataSetId, lod) {
      return new Promise(resolve => {
        let params = { dataSetId, lod }
        saveVectorLodConfigService(params).then(response => {
          if (response.isSuccess) {
            let convertParams = { dataSetId, execConvertingCallback: '' }
            submitVectorConvertService(convertParams).then(result => {
              if (result.isSuccess) {
                resolve(result)
              } else {
                this.$message.error(result.errMsg)
              }
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    async loopRequest(promiseArray, num, exceptionFiles = []) {
      let count = 0
      while (promiseArray.length > 0) {
        const temp = promiseArray.splice(0, num)
        await new Promise(resolve => setTimeout(resolve, 500)) // 添加一个延迟等待时间
        try {
          const responses = await Promise.all(temp)
          responses.forEach((res, index) => {
            if (!res.isSuccess) {
              res.index = index + count
              exceptionFiles.push(res)
            }
          })
        } catch (error) {
          console.error(error)
        }
        count += num
      }
      return exceptionFiles
    },
    closeVectorConfigDialog() {
      this.vectorConfigDialogVisible = false
      this.dataSetsToConvert = []
      this.vectorLodInfo = {}
      this.nodeInfo = null
    },
    updateModelTableVisible(total) {
      let visible = false
      if (total) {
        visible = true
      }
      this.modelTableVisible = visible

      this.$nextTick(() => {
        this.initUploadBtn()

        let projName = this.$route.params.projName
        let levelPathName = this.selectNodeData.levelPathName
        this.customUploader.setCurrDataSetId(this.selectNodeData.nodeId)
        this.customUploader.setUploadPathName(`${projName}/${levelPathName}`)
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('vector-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({ id: '#vector-upload' })
        }
      }

      // 空态页上传按钮
      let emptyUploadDom = document.getElementById('empty-vector-upload')
      if (emptyUploadDom) {
        let child = emptyUploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({
            id: '#empty-vector-upload'
          })
        }
      }
    },
    isBatchButtonVisible(buttonName, parentButtonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        if (parentButtonName) {
          let childrens = vectorButtons.find(
            el => el.name === parentButtonName
          ).children
          let find = childrens.find(el => el.name === buttonName)
          visible = this.isChecked(find.permissionCode)
        } else {
          let childrens = vectorButtons.find(
            el => el.name === buttonName
          ).children
          visible = childrens.some(el => this.isChecked(el.permissionCode))
        }

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    isButtonVisible(buttonName) {
      let visible = false
      if (Object.keys(this.selectNodeData).length) {
        let find = vectorButtons.find(el => el.name === buttonName)
        visible = this.isChecked(find.permissionCode)

        if (visible) {
          visible = this.selectNodeData.isAuthorized
        }
      }
      return visible
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    getParentNode,
    findNodeById
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';

.data-content-box {
  .data-content {
    margin-left: 16px;
    padding: 16px;
    margin-bottom: 0;
    overflow: hidden;
    .operate-area {
      width: 100%;
    }

    .data-view-box {
      height: calc(100% - 96px);
    }
  }
}
.vector-box {
  height: 100%;
}
</style>
